import api from './api';

export const analyticsService = {
    // Sistem istatistiklerini getir
    getSystemStats: async (period = 'today') => {
        const response = await api.get(`/admin/statistics?period=${period}`);
        return response.data;
    },

    // AI kullanım istatistiklerini getir
    getAIUsageStats: async (period = 'today') => {
        const response = await api.get(`/admin/ai-usage?period=${period}`);
        return response.data;
    },

    // Özel rapor oluştur
    generateReport: async (type, startDate, endDate) => {
        const response = await api.get(`/admin/reports?type=${type}&start_date=${startDate}&end_date=${endDate}`);
        return response.data;
    },

    // AI Monitoring metodları
    getAIMonitoringStats: async (period = 'today') => {
        const response = await api.get(`/admin/ai-usage?period=${period}`);
        return response.data;
    },

    getAICostAnalysis: async (period = 'today') => {
        // Bu endpoint henüz yok, ancak ileride eklenebilir
        // Şimdilik ai-usage endpoint'ini kullanıyoruz
        const response = await api.get(`/admin/ai-usage?period=${period}`);
        return response.data;
    }
};